import { AGGREGATE_NAMES } from 'cpool-constants';

import { useGetOwnCorporation } from '~/features/userStructures/hooks/corporation/useGetOwnCorporation';
import { useCaptureChatEntryLoadError } from '~/features/whatsapp/hooks/useCaptureChatEntryLoadError';
import { findOwnDivisionPhoneNumberId } from '~/features/whatsapp/utils/findOwnDivisionPhoneNumberId';
import useUserInfo from '~/hooks/useUserInfo';

// undefined = user/corporation unresolved or query ACL-disabled, null = corporation request failed
export const useHasOwnDivisionPhoneNumber = (): boolean | null | undefined => {
    const user = useUserInfo();
    const { data: corporation, error, isPending } = useGetOwnCorporation();

    const hasPhoneNumber = (() => {
        if (!user) return undefined;
        if (!user.divisionId) return false;
        if (isPending) return undefined;
        if (!corporation) return null;
        return Boolean(findOwnDivisionPhoneNumberId(corporation, user.divisionId));
    })();
    useCaptureChatEntryLoadError(hasPhoneNumber === null ? error : null, AGGREGATE_NAMES.CORPORATION);

    return hasPhoneNumber;
};
